import styled from 'styled-components'

export const CheckboxAndRadioWrapper = styled.div`
  display: grid;
  grid-template-rows: ${({ gridTemplateRows }) =>
    `repeat(${gridTemplateRows}, 0fr)`};
  column-gap: 20px;
  row-gap: 10px;
  grid-auto-flow: column;

  .mantine-Checkbox-root {
    min-width: 100%;
    width: ${({ isOperadora }) =>
      isOperadora ? 'max-content' : 'min-content'};
  }
`
